export default __webpack_public_path__ + "static/media/support.c2638e55.svg";